import { CartItemUI } from './CartItemUI';
import { Item } from '../../../../types/interfaces';
import { CartItemLogic } from '@features/cart-item';

interface CartItemProps {
  item: Item;
  isSelected?: boolean;
  onSelectChange?: (checked: boolean) => void;
}

export const CartItem = ({ item, isSelected = false, onSelectChange }: CartItemProps): JSX.Element => {
  return <CartItemLogic item={item} CartItemUI={CartItemUI} isSelected={isSelected} onSelectChange={onSelectChange} />;
};
